<template>
      <div class="tab-wrapper grid gap-4">
            <div class="form">
                  <label for="chart">{{ $t('chart') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_chart')"></feather></label>
                  <multiselect name="chart" v-model="selectedChart" label="name" track-by="id" :multiple="false" :options="allCharts" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
            </div>
            <!-- <div class="form" v-if="showFor(['Soti', 'LassoV2', 'Lasso'])"> -->
            <div class="form">
                  <label for="map">{{ $t('map') }} <feather type="info" :size='10' stroke='#4b5563' v-tooltip="$t('tooltip_map')"></feather></label>
                  <multiselect name="map" v-model="map" :options="['Show','Hide']" :searchable="false" :close-on-select="true" :show-labels="false" :placeholder="$t('select')"></multiselect>
            </div>
      </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
      data(){
            return {

            }
      },
      computed: {
            ...mapGetters([
                'allCharts',
                'newReport',
                'chartName'
            ]),
            selectedChart: {
                  get() {
                        if(this.newReport.chart_id !== null) {
                              return this.allCharts.find(chart => chart.id === this.newReport.chart_id)
                        } else {
                              return null
                        }
                  },
                  set(value) {
                        if(value === null){
                              this.setNewReportItem({chart_id: null})
                              this.setNewReportItem({chart_name: null})
                        } else {
                              this.setNewReportItem({chart_id: value.id})
                              this.setNewReportItem({chart_name: value.name})
                        }
                  }
            },
            selectedStackBy: {
                  get() {
                        return this.newReport.stack_by
                  },
                  set(value) {
                        this.setNewReportItem({stack_by: value})
                  }
            },
            map: {
                  get() {
                        if(this.newReport.map === true) {
                              return 'Show'
                        } else if (this.newReport.map === false || this.newReport.map === null) {
                              return 'Hide'
                        } else {
                              return null
                        }
                  },
                  set(value) {
                        if(value === null || value === 'Hide'){
                              this.setNewReportItem({map: false})
                        } else {
                              this.setNewReportItem({map: true})
                        }
                  }
            },
      },
      methods: {
            ...mapMutations({
                  setNewReportItem: 'setNewReportItem'
            }),
            // showFor(services){
            //       // if selected report has service_name as provided in services, then show map
            //       let output = false;
            //       for(const service of services){
            //             if(this.newReport.service_name && this.newReport.service_name.toLowerCase() === service.toLowerCase()){
            //                   output = true
            //                   break;
            //             }
            //       }
            //       return output
            // },
      },
      watch: {
            selectedChart(){
                  if (this.chartName !== 'StackedBarChart') {
                        this.selectedStackBy = null
                  }
            }
      }
}
</script>

<style>

</style>
